import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { bindActionCreators } from "redux";
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as stdActions from "../../redux/actions/stdAction";
import PropTypes from "prop-types";
import AccomodationComponent from "../../components/Accomodation";
import * as accomodationActions from "../../redux/actions/accomodationAction";
import * as notificationActions from "../../redux/actions/notificationAction";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const Accomodation = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const accomodationReducer = useSelector((state) => state.accomodationReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  const dispatch = useDispatch();
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const notificationAction = bindActionCreators(notificationActions, dispatch);
  const accomodationAction = bindActionCreators(accomodationActions, dispatch);
  const userAuthAction = bindActionCreators(userAuthActions, dispatch);
  const notificationReducer = useSelector((state) => state.notification);
  const stdReducer = useSelector((state) => state.stdReducer);

  let stdAction = bindActionCreators(stdActions, dispatch);

  let urllocation = useLocation();
  // Call required apis for dropdown after first render
  useEffect(() => {
    stdAction.prepareStdConfigData(profileReducer.managersDetails.companyId);
  }, []);


  //get All Pending Application
  const getAllPendingApplications = (managerId) => {
    notificationAction.getAllPendingApplications(managerId);
  }

  const setOnSubmit = (isOnSubmit) => {
    notificationAction.setOnSubmit(isOnSubmit);
  }

  //set maxcount in form  
  const setMaximumFormStep = (maxCount) => {
    accomodationAction.setMaximumFormStep(maxCount);
  };

  //set minmum Count in Form
  const setMinimumFormStep = (minCount) => {
    accomodationAction.setMinimumFormStep(minCount);
  };

  //set Current Form Step
  const setCurrentFormStep = (stepCount) => {
    accomodationAction.setCurrentFormStep(stepCount);
  };

  //change language
  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  //for side menu open and close
  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  //for open modal
  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  //for closing modal
  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const resetIsAdded = (isAdded) => {
    accomodationAction.resetIsAdded(isAdded);
  };

  //save accomodation
  const addAccomodationStatement = (accomodationData) => {
    accomodationAction.addAccomodationStatement(accomodationData, profileReducer.managersDetails.managerId);
  };

  //resetting accomodation modal
  const resetAccomodationApplicationUrl = () => {
    accomodationAction.resetAccomodationApplicationUrl();
  };

  //reset acmd reducer
  const resetACCMDReducer = () => {
    accomodationAction.resetState();
  }

  //get jon by location id
  const getJob = (locationID) => {
    commonAction.getJob(locationID);
  };

  //set job details
  const setJob = (jobDetails) => {
    commonAction.setJob(jobDetails);
  };

  //add new job title
  const addNewJobTitle = (jobDetail, locationID) => {
    commonAction.addNewJobTitle(jobDetail, locationID);
  };

  //add new modal
  const addNewManager = (managerDetails) => {
    commonAction.addNewManager(managerDetails);
  };

  const resetSuccessMessage = (message) => {
    commonAction.setSuccessMessage(message);
  }

  const resetsuccessMessageForBackupUserAssigned = () => userAuthAction.resetsuccessMessageForBackupUserAssigned();


  //upload acmd file
  const uploadFiles = (file, allFiles, props) => {
    accomodationAction.uploadFiles(file, allFiles, props);
  };

  //remove acmd file
  const removeFiles = (filePath, isDocs, index, allAttachments) => {
    accomodationAction.removeFiles(filePath, isDocs, index, allAttachments);
  };

  //set attachment
  const setAttachment = (attachment) => {
    accomodationAction.setAttachment(attachment);
  };

  const resetAcmdEmployeeStatement = () => accomodationAction.resetAcmdEmployeeStatement();

  //get all country province
  const getStates = (contryId) => {
    stdAction.getState(contryId);
  }

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <ShowForPermission module={PERMISSON_MODULES.ACMD_FORM} permission={PERMISSION_TYPE.VIEW}>
          <AccomodationComponent
            notificationReducer={notificationReducer}
            urlLocation={urllocation}
            clientinfo={stdReducer.clientInfo}
            stepCount={accomodationReducer.step}
            maxStep={accomodationReducer.maxSteps}
            minStep={accomodationReducer.minSteps}
            setMaxStep={setMaximumFormStep}
            setMinStep={setMinimumFormStep}
            setCurrentFormStep={setCurrentFormStep}
            managersDetails={profileReducer.managersDetails}
            context={context}
            addAccomodationStatement={addAccomodationStatement}
            i18nReducerLang={i18nReducer.lang}
            isAdded={accomodationReducer.isAdded}
            accomodationFormPdfLink={accomodationReducer.accomodationFormPdfLink}
            resetIsAdded={resetIsAdded}
            resetAccomodationApplicationUrl={resetAccomodationApplicationUrl}
            allPendingApplications={notificationReducer.allPendingApplications}
            resetACCMDReducer={resetACCMDReducer}
            openSetModalAction={openSetModal}
            getAllPendingApplications={getAllPendingApplications}
            closeRemoveModal={closeRemoveModal}
            contiuedPendingApplicationObj={accomodationReducer.acmdEmployeeStatement}
            resetContiuedPendingApplicationObj={resetAcmdEmployeeStatement}
            state={stdReducer.state}
            country={stdReducer.country}
            region={stdReducer.region}
            location={stdReducer.location}
            planLink={stdReducer.planLink}
            supervisorList={stdReducer.supervisorList}
            job={commonReducer.job}
            getJob={getJob}
            setJob={setJob}
            addNewJobTitle={addNewJobTitle}
            addNewManager={addNewManager}
            attachment={accomodationReducer.attachment}
            removeFiles={removeFiles}
            uploadFiles={uploadFiles}
            setAttachment={setAttachment}
            profileReducer={profileReducer}
            resetSuccessMessage={resetSuccessMessage}
            commonReducer={commonReducer}
            resetsuccessMessageForBackupUserAssigned={resetsuccessMessageForBackupUserAssigned}
            getStates={getStates}
          />
        </ShowForPermission>
      </div>
    </>
  );
};

Accomodation.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Accomodation;
